import React, { MouseEventHandler, memo, useContext } from 'react';
import { Tooltip, Button, Divider } from 'antd';
import { FiLock, FiUnlock } from 'react-icons/fi';
import CustomTag from '@components/CustomTag';
import SessionContext from '@providers/Session/SessionContext';

import * as S from './styles';

interface PadlockStatusColumnProps {
  isOpen: boolean;
  openText: string;
  closedText: string;
  openActionTooltip: string;
  closedActionTooltip: string;
  onAction: MouseEventHandler<HTMLElement>;
  disabled?: boolean;
}

const PadlockStatusColumn = ({
  isOpen,
  openText,
  closedText,
  openActionTooltip,
  closedActionTooltip,
  onAction,
  disabled,
}: PadlockStatusColumnProps) => {
  const { theme } = useContext(SessionContext);

  const colorTag = isOpen ? 'green' : 'red';
  const iconTag = isOpen ? (
    <FiUnlock color={theme?.colors?.red} />
  ) : (
    <FiLock color={theme?.colors?.green} />
  );
  const tagText = isOpen ? openText : closedText;
  const tooltipActionText = isOpen ? closedActionTooltip : openActionTooltip;

  return (
    <S.PadlockStatusContainer>
      <CustomTag className="padlock-status-tag" color={colorTag}>
        {tagText}
      </CustomTag>
      {!disabled && (
        <>
          <Divider type="vertical" className="padlock-status-divider" />
          <Tooltip title={tooltipActionText}>
            <Button
              size="small"
              onClick={onAction}
              icon={iconTag}
              className="padlock-status-button"
            />
          </Tooltip>
        </>
      )}
    </S.PadlockStatusContainer>
  );
};

export default memo(PadlockStatusColumn);
